// TOIDO: move to shared utils (fix import issues first)

import { ActivatedRoute } from "@angular/router";

export class Guid {
  static Empty = '00000000-0000-0000-0000-000000000000';
  static newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  static isValid(val: string) {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(val);
  }
}

export function clone(item: any): any {
  return item === undefined ? undefined : Array.isArray(item)
    ? item.map(_ => clone(_)) : JSON.parse(JSON.stringify(item));
}

export function removeEmpty(obj: any) {
  for (const key in obj) {
    if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
      delete obj[key];
    } else if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
      removeEmpty(obj[key]);
    }
  }
  return obj;
}

export const formatFullDateTime = (date: Date, timezone: string): string => date.toLocaleString("en-US", { timeZone: timezone, dateStyle: "full", timeStyle: "full" });
export const parseDate = (date: any) => {
  try {
    const result = new Date(date);
    if (!date || !result || result?.toString() === 'Invalid Date') return undefined;
    return result;
  }
  catch (e) { return undefined; }
}

export function formatPhone(phone?: string): { phone?: string; error?: string; } {
  if (!phone) return { phone, error: "Phone number is required" };
  //TODO: include international phone formats
  const cleaned = ('' + phone).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match)
    return { phone: `(${match[1]}) ${match[2]}-${match[3]}` };

  // phone = String(phone);
  // const phoneRegex = /^(\+?)([0-9]{1,3})([0-9]{3})([0-9]{3,4})$/;
  // const match = phone.match(phoneRegex);
  // if (match)
  //   return { phone: `${match[2]}${match[3]}${match[4]}` };

  return { phone, error: "Invalid phone number format" };
}

export function addHeaderTag(tag: string, attributes: { [key: string]: string }) {
  const element = document.createElement(tag);
  for (const key in attributes) {
    element.setAttribute(key, attributes[key]);
  }
  document.head.appendChild(element);
}

export function getRouteParam(route: ActivatedRoute, param: string): string | undefined {
  let r: ActivatedRoute | null = route;
  while (r) {
    if (r.snapshot.params[param]) return r.snapshot.params[param];
    r = r.parent;
  }
  return undefined;
}

export function getObjectPaths(obj: any, prefix = '') {
  let paths: string[] = [];

  if (Array.isArray(obj)) {
    prefix = `${prefix || ''}[]`;
    paths.push(prefix);
    obj = obj[0];
  }

  for (let key in obj) {
    const path = prefix ? `${prefix}.${key}` : key;

    if (Array.isArray(obj[key])) {
      paths = paths.concat(getObjectPaths(obj[key], path));
      // paths.push(path);

      // obj[key].forEach((item: any, index: number) => {
      //   if (typeof item === 'object' && item !== null)
      //     for (let itemKey in item)
      //       paths.push(`${path}[].${itemKey}`);
      // });
    } else if (obj[key] && typeof obj[key] === 'object') {
      paths.push(path);
      paths = paths.concat(getObjectPaths(obj[key], path));
    } else paths.push(path);
  }

  return paths;
}

export function translateWithCasing(str: string, translations: { [key: string]: string; }) {
  if (!str) return str;

  // 1. Exact match
  if (translations[str])
    return translations[str];


  // 2. Case-insensitive lookup
  const lower = str.toLowerCase();
  const ciKey = Object.keys(translations).find(k => k.toLowerCase() === lower);
  if (ciKey) {
    const rawValue = translations[ciKey];
    return applyCasing(str, rawValue);
  }

  // 3. No match → return original
  return str;
}

function applyCasing(source: string, target: string): string {
  // ALL UPPER
  if (source === source.toUpperCase())     return target.toUpperCase();
  
  // all lower
  if (source === source.toLowerCase())     return target.toLowerCase();

  // Capitalized? (first upper, rest lower)
  if (
    source[0] === source[0].toUpperCase() &&
    source.slice(1) === source.slice(1).toLowerCase()
  ) 
    return target.charAt(0).toUpperCase() + target.slice(1).toLowerCase();

  // any other mixed case → leave as-is
  return target;
}
